import type {PreOrderRetrieveResponse} from '@yandex-delivery/api/repo/dcaa'
import type {CargoItemMP} from '@yandex-delivery/types/schemas/delivery-corp-account-api/definitions'
import {
  flow,
  get,
  identity,
  ifElse,
  isUndefined,
  pipe,
  toCentimeter,
  toDefaultEmptyString,
} from '@yandex-delivery/utils'

import type {Parcel, Product} from 'src/shared/types'
import {ParcelPaymentType} from 'src/shared/types'

const toProduct = (cargoItemMP: CargoItemMP): Product => ({
  name: cargoItemMP.title,
  count: cargoItemMP.quantity,
  price: cargoItemMP.cost_value,
  estimatedCost: 0,
  nds: 0,
  inn: '',
  width: pipe(
    cargoItemMP,
    get('size.width'),
    ifElse(isUndefined, toDefaultEmptyString, identity),
    flow(toCentimeter, String),
  ),
  height: pipe(
    cargoItemMP,
    get('size.height'),
    ifElse(isUndefined, toDefaultEmptyString, identity),
    flow(toCentimeter, String),
  ),
  length: pipe(
    cargoItemMP,
    get('size.length'),
    ifElse(isUndefined, toDefaultEmptyString, identity),
    flow(toCentimeter, String),
  ),
  weight: String(cargoItemMP.weight),
  marking: cargoItemMP.extra_id,
})

export const toParcels = (preOrderRetrieve: PreOrderRetrieveResponse, pointId: number): Parcel[] => {
  const items = preOrderRetrieve.claim.items ?? []

  return [
    {
      name: '',
      barcode: '',
      payment: ParcelPaymentType.Payed,
      size: 'custom',
      products: items.filter(item => item.droppof_point === pointId).map(toProduct),
    },
  ]
}
